'use client';

import { useState } from 'react';
import BookingForm from './BookingForm';
import PricingPlans from './PricingPlans';
import FeaturesSection from './FeaturesSection';
import HowItWorks from './HowItWorks';
import FAQSection from './FAQSection';
import TrustBadges from './TrustBadges';

export default function OnwardTicketInteractive() {
  const [selectedPlan, setSelectedPlan] = useState<string>('standard');

  return (
    <div className="space-y-12">
      {/* Trust Badges */}
      <TrustBadges />

      {/* Pricing Plans */}
      <PricingPlans selectedPlan={selectedPlan} onSelectPlan={setSelectedPlan} />

      {/* Booking Form */}
      <BookingForm selectedPlan={selectedPlan} />

      {/* Features */}
      <FeaturesSection />

      {/* How It Works */}
      <HowItWorks />

      {/* FAQ */}
      <FAQSection />
    </div>
  );
}